import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { deleteSupportRequest, deleteSupportRequestError, deleteSupportRequestSuccess } from "../../../slices/teams/members/DeleteSupportSlice";

export const DeleteSupportAPI = (id) => {


    const url = `${endpoints.deleteSupport}/${id}`;

    return async (dispatch) => {
        try {
            dispatch(deleteSupportRequest());
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
                // headers: { "Content-Type": "application/json" },
            })
            return dispatch(deleteSupportRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteSupportRequestError(_error));
        }
    };
};
